export function gtag(..._) {
  var _window;
  if (typeof window === "undefined" || !((_window = window) !== null && _window !== void 0 && (_window = _window.dataLayer) !== null && _window !== void 0 && _window.push)) return;
  // Must be using 'arguments' & non-arrow function to push the callback into dataLayer
  // eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-unsafe-argument
  window.dataLayer.push(arguments);
}